/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsVulnerabilityTrendBySeverity {
    getFixupPrototypeFunction() { return AppSecopsVulnerabilityTrendBySeverity.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsVulnerabilityTrendBySeverity>): AppSecopsVulnerabilityTrendBySeverity {
        let obj = Object.assign(new AppSecopsVulnerabilityTrendBySeverity(), model);
        AppSecopsVulnerabilityTrendBySeverity.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsVulnerabilityTrendBySeverity>): AppSecopsVulnerabilityTrendBySeverity {
        if (!model) return null;
        return AppSecopsVulnerabilityTrendBySeverity.newInstance(<AppSecopsVulnerabilityTrendBySeverity> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsVulnerabilityTrendBySeverity) {
        if (!obj) return;

        models.AppSecopsVulnerabilityTrendBySeverity.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsVulnerabilityTrendBySeverity): boolean {
        Object.setPrototypeOf(obj, AppSecopsVulnerabilityTrendBySeverity.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.critical_count === undefined) {
            this.critical_count = 0;
        }
        if (this.high_count === undefined) {
            this.high_count = 0;
        }
        if (this.medium_count === undefined) {
            this.medium_count = 0;
        }
        if (this.low_count === undefined) {
            this.low_count = 0;
        }
        if (this.none_count === undefined) {
            this.none_count = 0;
        }
        if (this.unknown_count === undefined) {
            this.unknown_count = 0;
        }
        if (this.info_count === undefined) {
            this.info_count = 0;
        }
        if (typeof this.date === "string") {
            this.date = new Date(<string><any>this.date);
        }
    }

    /**
     * date of the aggregated time interval.
     */
    date: Date;

    /**
     * List of sbom version ID(s) that are associated with the vulnerabilities detected in the time interval.
     */
    sbom_version_ids: Array<string>;

    /**
     * Total count of vulnerabilities with critical severity.
     */
    critical_count: number;

    /**
     * Total count of vulnerabilities with high severity.
     */
    high_count: number;

    /**
     * Total count of vulnerabilities with medium severity.
     */
    medium_count: number;

    /**
     * Total count of vulnerabilities with low severity.
     */
    low_count: number;

    /**
     * Total count of vulnerabilities with none severity.
     */
    none_count: number;

    /**
     * Total count of vulnerabilities with unknown severity.
     */
    unknown_count: number;

    /**
     * Total count of vulnerabilities with info severity.
     */
    info_count: number;

}
